/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable no-param-reassign */
import { Chip, Grid, makeStyles, TextField } from '@material-ui/core';
import React from 'react';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import WarningIcon from '@material-ui/icons/Warning';
import { regexExp } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  values: string[];
  setFieldValue?: (field: string, value: any) => void;
  label: string;
  styles?: any;
}

interface EmailValuesProps {
  value: string;
  error: boolean;
}

const InputAdornmentChip = ({
  values,
  label,
  setFieldValue,
  stateKey,
  styles,
}: GenericFormItem & Props) => {
  const classes = useStyles();

  const [inputValue, setInputValue] = React.useState<string[]>(values);
  const [emailValues, setEmailValues] = React.useState<EmailValuesProps[]>([]);

  function handleInputChange(event) {
    const value = event.target.value.trim();

    if (event.key === 'Enter') {
      const newValues = value
        .split(/[,; ]+/)
        .filter(item => regexExp.isEmail.test(item));

      setInputValue([...inputValue, ...newValues]);
      event.target.value = '';
    }
  }

  function handleOnBlurChange(event) {
    const value = event.target.value.trim();

    if (event.target.value !== '') {
      const newValues = value
        .split(/[,; ]+/)
        .filter(item => regexExp.isEmail.test(item));

      setInputValue([...inputValue, ...newValues]);
    }
    event.target.value = '';
  }

  function handleDelete(item) {
    const newSelectedItem = [...emailValues];

    newSelectedItem.splice(newSelectedItem.indexOf(item), 1);
    setEmailValues(newSelectedItem);

    const newInputValue = [...inputValue];
    newInputValue.splice(newInputValue.indexOf(item.value), 1);
    setInputValue(newInputValue);
  }

  React.useEffect(() => {
    inputValue
      .filter(item => regexExp.isEmail.test(item))
      .forEach(item =>
        setEmailValues(prevState => {
          if (!prevState.find(value => value.value === item)) {
            return [
              ...prevState,
              {
                value: item,
                error: !regexExp.isEmail.test(item),
              },
            ];
          }

          return prevState;
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  React.useEffect(() => {
    if (setFieldValue) {
      const data: string[] = [];
      emailValues.forEach(item => data.push(item.value));
      setFieldValue(stateKey, data.toString() || '');
    }
  }, [emailValues, setFieldValue, stateKey]);

  return (
    <Grid
      className={classes.container}
      style={styles}
      container
      data-testid={'autosky-inputadornmentchip'}
    >
      <TextField
        id="outlined-basic"
        className={classes.root}
        label={label}
        variant="outlined"
        onBlur={handleOnBlurChange}
        InputProps={{
          startAdornment: !emailValues
            ? []
            : emailValues.map(item => (
                <Chip
                  icon={item.error ? <WarningIcon fontSize="small" /> : <></>}
                  key={item.value}
                  label={item.value}
                  onDelete={() => handleDelete(item)}
                />
              )),

          onKeyPress: event => {
            handleInputChange(event);
          },
          onChange: event => {
            handleInputChange(event);
          },
        }}
      />
    </Grid>
  );
};

export default InputAdornmentChip;
